/*
 * Portal de trocas e devoluções da Lab77 (tema Shopify).
 * Fonte oficial: repositório f77-backend, pasta shopify/lab77-portal-trocas/.
 *
 * Regra de segurança deste arquivo: dado vindo do ERP ou digitado pelo cliente só
 * entra na página por textContent/atributo — nunca por innerHTML. O portal roda no
 * domínio da loja; qualquer HTML injetado rodaria dentro do lab77.com.br.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-lab77-trocas]');
  if (!raiz) return;

  var API = raiz.getAttribute('data-api');
  var LOJA = raiz.getAttribute('data-loja') || 'lab77';

  var MOTIVOS = [
    { valor: 'defeito', texto: 'Produto com defeito', prazo: '30 dias da entrega' },
    { valor: 'errado', texto: 'Veio errado ou diferente do pedido', prazo: '30 dias da entrega' },
    { valor: 'tamanho_pequeno', texto: 'Ficou pequeno', prazo: '30 dias da entrega' },
    { valor: 'tamanho_grande', texto: 'Ficou grande', prazo: '30 dias da entrega' },
    { valor: 'caimento', texto: 'Não gostei do caimento', prazo: '30 dias da entrega' },
    { valor: 'nao_gostei_produto', texto: 'Não gostei do produto', prazo: '30 dias da entrega' },
    { valor: 'atraso_entrega', texto: 'Demora na entrega', prazo: '30 dias da entrega' },
    { valor: 'arrependimento', texto: 'Arrependimento', prazo: '30 dias da entrega' },
  ];

  var RESOLUCOES = [
    { valor: 'reembolso', texto: 'Devolver com reembolso', dica: 'O valor volta pelo mesmo meio de pagamento.' },
    { valor: 'troca_grade', texto: 'Trocar o tamanho', dica: 'Mesmo produto, outro tamanho.' },
    { valor: 'troca_outro', texto: 'Trocar por outro produto', dica: 'Você diz qual; a gente confirma a diferença de valor.' },
    { valor: 'vale_troca', texto: 'Vale-troca', dica: 'Crédito para usar em outra compra.' },
  ];

  var TAMANHOS = ['PP', 'P', 'M', 'G', 'GG', 'XGG', 'G3'];

  var FASES = [
    { nome: 'Solicitação recebida', dica: 'Nossa equipe está analisando.' },
    { nome: 'Aguardando postagem', dica: 'Envie o produto seguindo as instruções abaixo.' },
    { nome: 'A caminho', dica: 'O produto está a caminho da Lab77.' },
    { nome: 'Recebido', dica: 'O produto chegou ao nosso galpão.' },
    { nome: 'Em conferência', dica: 'Nossa equipe está avaliando o produto.' },
    { nome: 'Concluída', dica: 'Troca ou reembolso a caminho.' },
  ];

  var FASE_DO_STATUS = {
    aberto: 0,
    aguardando_postagem: 1,
    em_transito: 2,
    recebida: 3,
    em_conferencia: 4,
    aguardando_aprovacao_dupla: 4,
    emitindo_nf: 4,
    nf_rejeitada: 4,
    aprovada: 5,
    fechada: 5,
  };

  var SITUACOES_ESPECIAIS = {
    recusada: { titulo: 'Solicitação recusada', texto: 'O produto não atendeu aos critérios de troca. Nossa equipe vai entrar em contato.' },
    encerrada_recusa: { titulo: 'Solicitação encerrada', texto: 'Este atendimento foi finalizado.' },
    devolvendo_ao_cliente: { titulo: 'Produto voltando para você', texto: 'O produto está sendo reenviado para o endereço do pedido.' },
    extraviada: { titulo: 'Pacote não localizado', texto: 'Os Correios não localizaram o pacote. Nossa equipe vai entrar em contato.' },
    expirada: { titulo: 'Prazo de postagem vencido', texto: 'O prazo para postar o produto terminou. Fale com a gente se ainda precisar de ajuda.' },
    cancelada: { titulo: 'Solicitação cancelada', texto: 'Esta solicitação foi cancelada.' },
  };

  // Mensagens por código de erro do ERP. O texto do servidor é técnico; o cliente vê estes.
  var MENSAGEM_DO_CODIGO = {
    prazo_expirado: 'O prazo para solicitar por esse motivo já terminou. Se tiver dúvida, fale com a gente pelo WhatsApp.',
    quantidade_invalida: 'Confira a quantidade de cada item: ela não pode passar do que foi comprado.',
    item_nao_encontrado: 'Não encontramos um dos itens neste pedido. Recarregue a página e tente de novo.',
    cpf_invalido: 'Confira o CPF: ele precisa ter 11 números.',
    idempotency_conflito: 'Recarregue a página e tente de novo.',
    cliente_obrigatorio: 'Não conseguimos concluir pelo portal. Fale com a gente pelo WhatsApp (21) 99364-0087.',
    rma_ja_existe: 'Já existe uma solicitação aberta para este pedido. Consulte de novo para acompanhar.',
    motivo_invalido: 'Escolha o motivo de novo e tente enviar.',
  };

  var estado = {
    pedidoNumero: '',
    identificador: '',
    token: null,
    pedido: null,
    cpfDoLogin: '',
    chaveEnvio: null,
    itens: new Map(),
  };

  // ── utilitários ────────────────────────────────────────────────────

  function parte(nome) {
    return raiz.querySelector('[data-lt="' + nome + '"]');
  }

  function el(tag, props) {
    var no = document.createElement(tag);
    props = props || {};
    Object.keys(props).forEach(function (chave) {
      var valor = props[chave];
      if (valor == null) return;
      if (chave === 'classe') no.className = valor;
      else if (chave === 'texto') no.textContent = valor;
      else no.setAttribute(chave, valor);
    });
    for (var i = 2; i < arguments.length; i++) {
      var filho = arguments[i];
      if (filho == null || filho === false) continue;
      no.appendChild(typeof filho === 'string' ? document.createTextNode(filho) : filho);
    }
    return no;
  }

  function mostrar(elemento, sim) {
    if (elemento) elemento.hidden = !sim;
  }

  function reais(valor) {
    return (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function dataHora(texto) {
    if (!texto) return '';
    var d = new Date(String(texto).replace(' ', 'T'));
    if (isNaN(d)) return String(texto);
    return d.toLocaleDateString('pt-BR') + ' às ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  function formatarCpf(valor) {
    var d = String(valor).replace(/\D/g, '').slice(0, 11);
    if (d.length <= 3) return d;
    if (d.length <= 6) return d.slice(0, 3) + '.' + d.slice(3);
    if (d.length <= 9) return d.slice(0, 3) + '.' + d.slice(3, 6) + '.' + d.slice(6);
    return d.slice(0, 3) + '.' + d.slice(3, 6) + '.' + d.slice(6, 9) + '-' + d.slice(9);
  }

  function novaChave() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
  }

  function linkHttps(url) {
    try {
      var u = new URL(String(url));
      return u.protocol === 'https:' ? u.toString() : null;
    } catch (_) {
      return null;
    }
  }

  function erroDoPortal(tipo, mensagem) {
    var e = new Error(mensagem || '');
    e.tipo = tipo;
    return e;
  }

  // ── conversa com o ERP ─────────────────────────────────────────────

  async function chamar(metodo, caminho, corpo, cabecalhos) {
    var headers = { 'Content-Type': 'application/json' };
    if (estado.token) headers.Authorization = 'Bearer ' + estado.token;
    Object.keys(cabecalhos || {}).forEach(function (k) { headers[k] = cabecalhos[k]; });

    var resposta;
    try {
      resposta = await fetch(API + caminho, {
        method: metodo,
        headers: headers,
        body: corpo ? JSON.stringify(corpo) : undefined,
        credentials: 'omit',
      });
    } catch (_) {
      throw erroDoPortal('indisponivel');
    }

    var dados = null;
    try { dados = await resposta.json(); } catch (_) { dados = null; }

    if (resposta.ok) return dados;
    if (resposta.status === 401) throw erroDoPortal('sessao');
    if (resposta.status >= 500) throw erroDoPortal('indisponivel');

    var codigo = dados && dados.code;
    var mensagem = (codigo && MENSAGEM_DO_CODIGO[codigo]) || (dados && dados.erro) || 'Não foi possível concluir. Tente de novo.';
    throw erroDoPortal('negocio', mensagem);
  }

  // ── navegação entre telas ──────────────────────────────────────────

  var TELAS = ['tela-busca', 'tela-itens', 'tela-enviada', 'tela-acompanhar', 'tela-indisponivel'];
  var PASSO_DA_TELA = { 'tela-busca': 1, 'tela-itens': 2, 'tela-enviada': 3 };

  function irPara(nome) {
    TELAS.forEach(function (t) { mostrar(parte(t), t === nome); });
    var passo = PASSO_DA_TELA[nome];
    mostrar(parte('passos'), !!passo);
    if (passo) {
      for (var i = 1; i <= 3; i++) {
        var marca = parte('passo-' + i);
        marca.classList.toggle('is-feito', i < passo);
        marca.classList.toggle('is-atual', i === passo);
        if (i === passo) marca.setAttribute('aria-current', 'step');
        else marca.removeAttribute('aria-current');
      }
    }
    var titulo = parte(nome).querySelector('.lt-titulo');
    if (titulo) titulo.focus({ preventScroll: true });
    raiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function mostrarErro(nomeCaixa, mensagem) {
    var caixa = parte(nomeCaixa);
    caixa.textContent = mensagem || '';
    mostrar(caixa, !!mensagem);
  }

  function tratarFalha(err, nomeCaixa) {
    if (err && err.tipo === 'indisponivel') {
      irPara('tela-indisponivel');
      return;
    }
    if (err && err.tipo === 'sessao') {
      recomecar(false);
      mostrarErro('erro-busca', 'Sua sessão expirou. Confira os dados e continue de novo.');
      return;
    }
    mostrarErro(nomeCaixa, (err && err.message) || 'Não foi possível concluir. Tente de novo.');
  }

  function ocupado(botao, sim, textoOcupado) {
    if (sim) {
      botao.dataset.textoOriginal = botao.textContent;
      botao.textContent = textoOcupado;
      botao.disabled = true;
      botao.setAttribute('aria-busy', 'true');
    } else {
      botao.textContent = botao.dataset.textoOriginal || botao.textContent;
      botao.disabled = false;
      botao.removeAttribute('aria-busy');
    }
  }

  // ── tela 1: identificação ──────────────────────────────────────────

  async function buscar() {
    var botao = parte('btn-buscar');
    var campoPedido = document.getElementById('lt-pedido');
    var campoId = document.getElementById('lt-identificador');
    var numero = campoPedido.value.trim().replace(/\s+/g, '');
    var identificador = campoId.value.trim();

    mostrarErro('erro-busca', '');
    if (!numero || !identificador) {
      mostrarErro('erro-busca', 'Preencha o número do pedido e o e-mail ou CPF.');
      return;
    }
    if (numero.charAt(0) !== '#') numero = '#' + numero;

    var digitos = identificador.replace(/\D/g, '');
    var ehEmail = identificador.indexOf('@') !== -1;
    if (!ehEmail && digitos.length !== 11) {
      mostrarErro('erro-busca', 'Digite um e-mail válido ou um CPF com 11 números.');
      return;
    }

    estado.pedidoNumero = numero;
    estado.identificador = identificador;
    estado.cpfDoLogin = ehEmail ? '' : digitos;

    ocupado(botao, true, 'Buscando…');
    try {
      var login = await chamar('POST', '/devolucoes/auth-lookup', {
        numero_pedido: numero,
        identificador: identificador,
        loja: LOJA,
      });
      estado.token = login.dados.sessionToken;

      var consulta = await chamar('POST', '/devolucoes/lookup-pedido', { numero_pedido: numero });
      estado.pedido = consulta.dados;

      if (estado.pedido.rma_ativo) {
        var situacao = await chamar('GET', '/devolucoes/' + encodeURIComponent(estado.pedido.rma_ativo.numero_rma) + '/status');
        mostrarAcompanhamento(estado.pedido.rma_ativo, situacao.dados);
        return;
      }

      montarItens();
      irPara('tela-itens');
    } catch (err) {
      tratarFalha(err, 'erro-busca');
    } finally {
      ocupado(botao, false);
    }
  }

  // ── tela 2: itens ──────────────────────────────────────────────────

  function montarItens() {
    var lista = parte('lista-itens');
    lista.textContent = '';
    estado.itens = new Map();
    estado.chaveEnvio = novaChave();

    parte('pedido-num').textContent = estado.pedidoNumero;
    var precisaCpf = !estado.cpfDoLogin && !(estado.pedido && estado.pedido.titular_id_capturado);
    mostrar(parte('bloco-cpf'), precisaCpf);
    mostrarErro('erro-itens', '');

    (estado.pedido.itens || []).forEach(function (item) {
      lista.appendChild(montarItem(item));
    });
    if (!estado.itens.size) {
      lista.appendChild(el('p', { classe: 'lt-texto-suave', texto: 'Não encontramos itens neste pedido. Fale com a gente pelo WhatsApp.' }));
    }
  }

  function montarItem(item) {
    var id = String(item.id);
    var prefixo = 'lt-item-' + id.replace(/[^0-9a-zA-Z_-]/g, '');
    var maximo = Math.max(1, parseInt(item.quantidade, 10) || 1);
    var valorUnit = Number(item.valor_unit) || 0;

    var marcar = el('input', { type: 'checkbox', id: prefixo + '-marcar' });
    var detalhe = [item.variante, item.sku ? 'SKU ' + item.sku : null, valorUnit ? reais(valorUnit) + ' cada' : null]
      .filter(Boolean).join(' · ');
    var topo = el('label', { classe: 'lt-item-topo', for: prefixo + '-marcar' },
      marcar,
      el('span', { classe: 'lt-item-info' },
        el('span', { classe: 'lt-item-nome', texto: item.produto || 'Produto' }),
        detalhe ? el('span', { classe: 'lt-item-detalhe', texto: detalhe }) : null,
        el('span', { classe: 'lt-item-detalhe', texto: 'Comprado: ' + maximo })));

    var quantidade = el('input', { type: 'number', id: prefixo + '-qtd', min: '1', max: String(maximo), value: String(maximo), inputmode: 'numeric' });
    var campoQtd = el('div', null,
      el('label', { classe: 'lt-rotulo', for: prefixo + '-qtd', texto: 'Quantidade a devolver' }), quantidade);

    var motivo = el('select', { id: prefixo + '-motivo' }, el('option', { value: '', texto: 'Selecione…' }));
    MOTIVOS.forEach(function (m) { motivo.appendChild(el('option', { value: m.valor, texto: m.texto })); });
    var prazo = el('p', { classe: 'lt-aviso' });
    motivo.addEventListener('change', function () {
      var m = MOTIVOS.filter(function (x) { return x.valor === motivo.value; })[0];
      prazo.textContent = m ? 'Prazo para esse motivo: ' + m.prazo + '.' : '';
    });
    var campoMotivo = el('div', null,
      el('label', { classe: 'lt-rotulo', for: prefixo + '-motivo', texto: 'Motivo' }), motivo, prazo);

    var opcoes = el('div', { classe: 'lt-opcoes', role: 'radiogroup', 'aria-label': 'Como resolver' });
    var radios = [];
    RESOLUCOES.forEach(function (r) {
      var radio = el('input', { type: 'radio', name: prefixo + '-resolucao', value: r.valor });
      radios.push(radio);
      opcoes.appendChild(el('label', { classe: 'lt-opcao' }, radio,
        el('span', null, el('strong', { texto: r.texto }), el('span', { classe: 'lt-opcao-dica', texto: r.dica }))));
    });
    var campoResolucao = el('div', null, el('span', { classe: 'lt-rotulo', texto: 'Como você quer resolver?' }), opcoes);

    var tamanho = el('select', { id: prefixo + '-tamanho' }, el('option', { value: '', texto: 'Selecione…' }));
    TAMANHOS.forEach(function (t) { tamanho.appendChild(el('option', { value: t, texto: t })); });
    var campoTamanho = el('div', { hidden: '' },
      el('label', { classe: 'lt-rotulo', for: prefixo + '-tamanho', texto: 'Tamanho que você quer' }), tamanho);

    var outro = el('input', { type: 'text', id: prefixo + '-outro', maxlength: '200', placeholder: 'Ex.: camiseta Box preta, tamanho M' });
    var campoOutro = el('div', { hidden: '' },
      el('label', { classe: 'lt-rotulo', for: prefixo + '-outro', texto: 'Qual produto você quer no lugar?' }), outro,
      el('p', { classe: 'lt-aviso', texto: 'Nossa equipe confirma o produto e a diferença de valor pelo WhatsApp.' }));

    var avisoValor = el('p', { classe: 'lt-aviso', hidden: '' });

    var obs = el('input', { type: 'text', id: prefixo + '-obs', maxlength: '500', placeholder: 'Ex.: a costura da gola abriu' });
    var campoObs = el('div', null,
      el('label', { classe: 'lt-rotulo', for: prefixo + '-obs', texto: 'Detalhes (opcional)' }), obs);

    var extras = el('div', { classe: 'lt-item-extras', hidden: '' },
      campoQtd, campoMotivo, campoResolucao, campoTamanho, campoOutro, avisoValor, campoObs);

    var cartao = el('div', { classe: 'lt-item' }, topo, extras);

    function resolucaoEscolhida() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? r.value : '';
    }

    function atualizarAviso() {
      var res = resolucaoEscolhida();
      var qtd = parseInt(quantidade.value, 10) || 0;
      mostrar(campoTamanho, res === 'troca_grade');
      mostrar(campoOutro, res === 'troca_outro');
      var comValor = (res === 'reembolso' || res === 'vale_troca') && valorUnit > 0 && qtd > 0;
      mostrar(avisoValor, comValor);
      if (comValor) {
        var total = reais(valorUnit * qtd);
        avisoValor.textContent = res === 'reembolso'
          ? 'Reembolso previsto: ' + total + ', pelo mesmo meio de pagamento do pedido.'
          : 'Crédito previsto: ' + total + ' para usar em outra compra.';
      }
    }

    marcar.addEventListener('change', function () {
      mostrar(extras, marcar.checked);
      cartao.classList.toggle('is-marcado', marcar.checked);
    });
    radios.forEach(function (r) { r.addEventListener('change', atualizarAviso); });
    quantidade.addEventListener('input', atualizarAviso);

    estado.itens.set(id, {
      id: item.id,
      maximo: maximo,
      marcar: marcar,
      quantidade: quantidade,
      motivo: motivo,
      resolucao: resolucaoEscolhida,
      tamanho: tamanho,
      outro: outro,
      obs: obs,
    });
    return cartao;
  }

  function coletarItens() {
    var escolhidos = [];
    var problema = null;
    estado.itens.forEach(function (ui) {
      if (problema || !ui.marcar.checked) return;
      var qtd = Number(ui.quantidade.value);
      if (!Number.isInteger(qtd) || qtd < 1 || qtd > ui.maximo) {
        problema = 'A quantidade de cada item vai de 1 até o que foi comprado.';
        return;
      }
      if (!ui.motivo.value) { problema = 'Escolha o motivo de cada item marcado.'; return; }
      var res = ui.resolucao();
      if (!res) { problema = 'Escolha como resolver cada item marcado.'; return; }

      var linha = {
        pedido_item_id: ui.id,
        quantidade: qtd,
        motivo: ui.motivo.value,
        motivo_descricao: ui.obs.value.trim().slice(0, 500),
        resolucao: res,
      };
      if (res === 'troca_grade') {
        if (!ui.tamanho.value) { problema = 'Escolha o tamanho que você quer na troca.'; return; }
        linha.troca_variante = ui.tamanho.value;
        linha.troca_quantidade = qtd;
      }
      if (res === 'troca_outro') {
        var desejado = ui.outro.value.trim().slice(0, 200);
        if (!desejado) { problema = 'Diga qual produto você quer no lugar.'; return; }
        linha.troca_variante = desejado;
        linha.troca_quantidade = qtd;
      }
      escolhidos.push(linha);
    });
    if (!problema && !escolhidos.length) problema = 'Marque pelo menos um item.';
    return { itens: escolhidos, problema: problema };
  }

  async function confirmar() {
    var botao = parte('btn-confirmar');
    mostrarErro('erro-itens', '');

    var coleta = coletarItens();
    if (coleta.problema) { mostrarErro('erro-itens', coleta.problema); return; }

    var cpf = estado.cpfDoLogin;
    if (!parte('bloco-cpf').hidden) {
      cpf = document.getElementById('lt-cpf').value.replace(/\D/g, '');
      if (cpf.length !== 11) { mostrarErro('erro-itens', MENSAGEM_DO_CODIGO.cpf_invalido); return; }
    }

    var email = estado.identificador.indexOf('@') !== -1 ? estado.identificador.toLowerCase() : '';

    ocupado(botao, true, 'Enviando…');
    try {
      var resposta = await chamar('POST', '/devolucoes', {
        itens: coleta.itens,
        cliente: { cpf: cpf, email: email },
      }, { 'Idempotency-Key': estado.chaveEnvio });
      parte('enviada-numero').textContent = (resposta.dados && resposta.dados.numero_solicitacao) || estado.pedidoNumero;
      irPara('tela-enviada');
    } catch (err) {
      tratarFalha(err, 'erro-itens');
    } finally {
      ocupado(botao, false);
    }
  }

  // ── acompanhamento ─────────────────────────────────────────────────

  function mostrarAcompanhamento(rma, situacao) {
    var status = (situacao && situacao.status) || rma.status;

    parte('acomp-pedido').textContent = estado.pedidoNumero;
    parte('acomp-rma').textContent = rma.numero_rma || '';
    parte('acomp-aberta').textContent = dataHora(rma.aberto_em);
    // Frete: pedido feito durante campanha promocional (cadastrada no ERP) já nasce
    // com o comprador pagando, e o motivo aparece por extenso. Fora de campanha,
    // quem paga só é garantido depois que a equipe aprova.
    var clientePaga = ((situacao && situacao.frete_pagador) || rma.frete_pagador) === 'cliente';
    var campanha = situacao && situacao.campanha;
    if (clientePaga) {
      parte('acomp-frete').textContent = 'Por conta do comprador';
    } else {
      parte('acomp-frete').textContent = status === 'aberto' ? 'Confirmado após a análise' : 'Por nossa conta';
    }
    mostrar(parte('aviso-frete'), !!(clientePaga && campanha));
    parte('aviso-frete-texto').textContent = clientePaga && campanha
      ? 'Para compras realizadas durante o ' + campanha + ', o custo de frete de troca é por conta do comprador.'
      : '';

    var reembolso = situacao && situacao.reembolso;
    mostrar(parte('acomp-reembolso-bloco'), !!(reembolso && Number(reembolso.valor) > 0));
    if (reembolso && Number(reembolso.valor) > 0) {
      parte('acomp-reembolso').textContent = reais(reembolso.valor) + ' · ' + (reembolso.status === 'pago' ? 'já processado' : 'pendente');
    }

    var etiqueta = (situacao && situacao.etiqueta) || null;
    var codigo = etiqueta && etiqueta.codigo;
    mostrar(parte('acomp-rastreio-bloco'), !!codigo);
    if (codigo) parte('acomp-rastreio').textContent = codigo;

    var linkEtiqueta = etiqueta ? linkHttps(etiqueta.url) : null;
    parte('link-etiqueta').removeAttribute('href');
    ['inst-analise', 'inst-etiqueta', 'inst-cliente-paga', 'inst-chegou', 'inst-finalizada'].forEach(function (n) {
      mostrar(parte(n), false);
    });
    if (status === 'aberto') mostrar(parte('inst-analise'), true);
    else if (status === 'aguardando_postagem' && linkEtiqueta) {
      parte('link-etiqueta').setAttribute('href', linkEtiqueta);
      mostrar(parte('inst-etiqueta'), true);
    } else if (status === 'aguardando_postagem') mostrar(parte('inst-cliente-paga'), true);
    else if (status === 'em_transito' && etiqueta && etiqueta.rastreio_status === 'entregue') mostrar(parte('inst-chegou'), true);
    else if (status === 'aprovada' || status === 'fechada') mostrar(parte('inst-finalizada'), true);

    montarLinhaDoTempo(status);
    irPara('tela-acompanhar');
  }

  function montarLinhaDoTempo(status) {
    var linha = parte('linha-tempo');
    var especial = SITUACOES_ESPECIAIS[status];
    linha.textContent = '';
    mostrar(parte('situacao-especial'), !!especial);
    mostrar(linha, !especial);
    if (especial) {
      parte('situacao-titulo').textContent = especial.titulo;
      parte('situacao-texto').textContent = especial.texto;
      return;
    }
    var atual = FASE_DO_STATUS[status];
    if (atual == null) atual = 0;
    FASES.forEach(function (fase, i) {
      var classe = 'lt-fase' + (i < atual ? ' is-feita' : i === atual ? ' is-atual' : '');
      var item = el('li', { classe: classe },
        el('span', { classe: 'lt-fase-marca', 'aria-hidden': 'true', texto: i < atual ? '✓' : String(i + 1) }),
        el('span', null,
          el('span', { classe: 'lt-fase-nome', texto: fase.nome }),
          i <= atual ? el('span', { classe: 'lt-fase-dica', texto: ' — ' + fase.dica }) : null));
      if (i === atual) item.setAttribute('aria-current', 'step');
      linha.appendChild(item);
    });
  }

  // ── recomeçar ──────────────────────────────────────────────────────

  // Computador compartilhado: nada da consulta anterior pode ficar escondido na página.
  function limparDadosDaConsulta() {
    parte('lista-itens').textContent = '';
    parte('linha-tempo').textContent = '';
    ['pedido-num', 'enviada-numero', 'acomp-pedido', 'acomp-rma', 'acomp-aberta', 'acomp-frete',
      'acomp-reembolso', 'acomp-rastreio', 'situacao-titulo', 'situacao-texto', 'aviso-frete-texto'].forEach(function (n) {
      parte(n).textContent = '';
    });
    mostrar(parte('aviso-frete'), false);
    parte('link-etiqueta').removeAttribute('href');
    mostrarErro('erro-itens', '');
  }

  function recomecar(limparCampos) {
    estado.token = null;
    estado.pedido = null;
    estado.itens = new Map();
    estado.chaveEnvio = null;
    limparDadosDaConsulta();
    if (limparCampos) {
      document.getElementById('lt-pedido').value = '';
      document.getElementById('lt-identificador').value = '';
      document.getElementById('lt-cpf').value = '';
      estado.cpfDoLogin = '';
    }
    mostrarErro('erro-busca', '');
    irPara('tela-busca');
  }

  // ── ligações ───────────────────────────────────────────────────────

  parte('btn-buscar').addEventListener('click', buscar);
  ['lt-pedido', 'lt-identificador'].forEach(function (id) {
    document.getElementById(id).addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); buscar(); }
    });
  });
  document.getElementById('lt-cpf').addEventListener('input', function (e) {
    e.target.value = formatarCpf(e.target.value);
  });
  parte('btn-confirmar').addEventListener('click', confirmar);
  parte('btn-voltar').addEventListener('click', function () { recomecar(false); });
  parte('btn-nova').addEventListener('click', function () { recomecar(true); });
  parte('btn-sair').addEventListener('click', function () { recomecar(true); });
  parte('btn-tentar').addEventListener('click', function () { recomecar(false); });
  parte('btn-copiar').addEventListener('click', async function () {
    var botao = parte('btn-copiar');
    try {
      await navigator.clipboard.writeText(parte('acomp-rastreio').textContent);
      botao.textContent = 'Copiado';
      setTimeout(function () { botao.textContent = 'Copiar'; }, 1500);
    } catch (_) {
      botao.textContent = 'Selecione e copie';
    }
  });
})();
